import { useGetRecipeCategories } from '../../../hooks';

export const useFilters = ({ filteredRecipes, selectedFilters }) => {
    const { data: recipeCategories = { CATEGORIES: [], DIET: [], GENRES: [], METHODS: [], PROTEIN: [], TYPES: [] } } = useGetRecipeCategories();
    const categories = recipeCategories.CATEGORIES;
    // const diet = recipeCategories.DIET;
    const genres = recipeCategories.GENRES;
    // const methods = recipeCategories.METHODS;
    // const protein = recipeCategories.PROTEIN;
    // const types = recipeCategories.TYPES;

    const filterMapping = [
        { heading: 'Categories', type: 'category', filterOptions: categories },
        { heading: 'Genres', type: 'genre', filterOptions: genres },
        // { heading: 'Diet', type: 'diet', filterOptions: diet },
        // { heading: 'Cooking Methods', type: 'method', filterOptions: methods },
        // { heading: 'Proteins', type: 'protein', filterOptions: protein },
        // { heading: 'Type', type: 'type', filterOptions: types },
        // { heading: 'Has Image', type: 'image', filterOptions: ['Yes', 'No'] },
        { heading: 'Still WIP', type: 'wip', filterOptions: ['Yes', 'No'] },
        { heading: 'Recommended', type: 'recommended', filterOptions: ['Yes', 'No'] },
        { heading: 'Available', type: 'available', filterOptions: ['Yes', 'No'] },
    ];

    const filterRecipeBySelectedFilters = (compared, filter) => {
        return compared.some(value => filter.find(v => v === value))
    }

    const checkAvailable = (available) => {
        const no = selectedFilters.available.includes('No');
        const yes = selectedFilters.available.includes('Yes');
        const all = no && yes;

        if (all) return true;
        if (no && !available) return true;
        if (yes && available) return true;
        return false;
    }

    const checkRecommended = (recommended) => {
        const no = selectedFilters.recommended.includes('No');
        const yes = selectedFilters.recommended.includes('Yes');
        const all = no && yes;

        if (all) return true;
        if (no && !recommended) return true;
        if (yes && recommended) return true;
        return false;
    }

    const checkSelectedImageOption = (img) => {
        const no = selectedFilters.image.includes('No');
        const yes = selectedFilters.image.includes('Yes');
        const all = no && yes;

        if (all) return true;
        if (no && !img) return true;
        if (yes && img) return true;
        return false;
    }

    const checkWIP = (wip) => {
        const no = selectedFilters.wip.includes('No');
        const yes = selectedFilters.wip.includes('Yes');
        const all = no && yes;

        if (all) return true;
        if (no && !wip) return true;
        if (yes && wip) return true;
        return false;
    }

    const availableFilteredRecipes = filteredRecipes.filter(item => !!item.available);
    const { available, category, diet, genre, image, method, protein, recommended, type, wip } = selectedFilters;
    const recipesToLookUp = process.env.NODE_ENV === 'development' && available.includes('No') ? filteredRecipes : availableFilteredRecipes;
    const filteredRecipeBySelectedFilters = recipesToLookUp.filter(item => {
        return (
            (!category.length || filterRecipeBySelectedFilters(item.category || [], category)) &&
            (!diet.length || filterRecipeBySelectedFilters(item.diet || [], diet)) &&
            (!genre.length || filterRecipeBySelectedFilters(item.genre || [], genre)) &&
            (!method.length || filterRecipeBySelectedFilters(item.method || [], method)) &&
            (!protein.length || filterRecipeBySelectedFilters(item.protein || [], protein)) &&
            (!type.length || filterRecipeBySelectedFilters(item.type || [], type)) &&
            (!image.length || checkSelectedImageOption(item.img)) &&
            (!wip?.length || checkWIP(item.wip)) &&
            (!recommended?.length || checkRecommended(item.recommended)) &&
            (!available?.length || checkAvailable(item.available))
        );
    });

    return {
        filterMapping,
        filteredRecipeBySelectedFilters,
    }
}